import { ru } from "vuetify/src/locale";

export default {
  ...ru,
  user: "Пользователь",
  password: "Пароль",
  language: "Язык",
  submit: "Отправить",
  theme: "Тема",
  sessionExits:
    "Сеанс с таким именем пользователя уже существует. Хотите все равно зарегистрироваться и уничтожить предыдущую сессию?",
  sessionKill: "Удалить сессию",
  wrongAuth: "Неверный пользователь или пароль",
  userDateExpired: "Срок действия пользовательской лицензии истек",
  dateExpired: "Срок действия лицензии истек",
  userNoRole: "У пользователя нет роли",
  userNoAccess: "У пользователя нет полномочий для дизайнера",
  sessionExpired: "Срок сессии истек",
  release: "Релиз",
  autologin: "Автоматический вход",
  blue: "Blue",
  dark: "Darkmode",
  material: "Material",
  quartz: "Quartz",
  horizon: "Horizon",
  client: "Клиент",
};
